export default "30b8b2c6306b8881.png"